module.exports = __webpack_public_path__ + "img/hip-roof.2912a978.png";